export default class NetworkError extends Error {
  constructor(error) {
    super();

    this.config = error.config;
    this.request = error.request;
    this.response = error.response;
  }
}
